<template>
  <div class=''>
    <div class="title">{{titleMsg}}</div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    titleMsg: {
      ttype: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang='scss' scoped>
.title {
  color: white;
  font-size: 18px;
  &::before {
    content: "";
    width: 6px;
    height: 24px;
    background-color: #209b9a;
    border-radius: 10px;
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
  }
}
</style>
